import React from 'react';
import { Link } from 'react-router-dom';

const BlogSeries = ({ posts, seriesTitle, seriesPath }) => (
  <div className="blog-page__container section section--light">
    <section className="page-header">
      <h1 className="page-header__title">{seriesTitle}</h1>
    </section>
    <section className="blog-posts-section">
      <div className="blog-posts__grid">
        {posts.map(post => (
          <div className="blog-post-card" key={post.num}>
            <div className="blog-post-card__content">
              <div className="blog-post-card__date">{post.date}</div>
              <h3 className="blog-post-card__title">
                <Link to={`${seriesPath}/${post.num}`} className="blog-post-card__link">
                  {post.title}
                </Link>
              </h3>
              {post.summary && (
                <div
                  className="blog-post-card__summary"
                  style={{
                    margin: '0.5rem 0 0.5rem 0',
                    color: '#4a5568',
                    fontSize: '1rem',
                    lineHeight: 1.5,
                  }}
                >
                  {post.summary}
                </div>
              )}
              {post.hashtags && post.hashtags.length > 0 && (
                <div
                  className="blog-post-card__hashtags"
                  style={{
                    color: '#7b8794',
                    fontSize: '0.95rem',
                    marginBottom: '0.5rem',
                    whiteSpace: 'normal',
                    wordBreak: 'break-word',
                  }}
                >
                  {post.hashtags.map(tag => (
                    <span
                      key={tag}
                      style={{
                        display: 'inline-block',
                        marginRight: '0.5em',
                        marginBottom: '0.15em',
                        whiteSpace: 'nowrap',
                        border: '1px solid #d1d5db',
                        background: '#f3f4f6',
                        borderRadius: '999px',
                        padding: '0.15em 0.75em',
                        fontWeight: 500,
                        fontSize: '0.97em',
                      }}
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              )}
              <Link
                to={`${seriesPath}/${post.num}`}
                className="blog-post-card__link blog-post-card__link--arrow"
              >
                Read More
              </Link>
            </div>
          </div>
        ))}
      </div>
    </section>
  </div>
);

export default BlogSeries;
